const Password = {
  // _pattern:
  //   /^(?=(?:([a-zA-Z0-9_\-+.!@#$%^&*])*?[a-z]){1})(?=(?:([a-zA-Z0-9_\-+.!@#$%^&*])*?[A-Z]){1})(?=(?:([a-zA-Z0-9_\-+.!@#$%^&*])*?[0-9]){1})(?=(?:([a-zA-Z0-9_\-+.!@#$%^&*])*?[_\-+.!@#$%^&*]){1}).{8}$/,

  // _characters: '123456789ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz+!@#$%&*',
  _numbers: '123456789',
  _uppers: 'ABCDEFGHJKMNPQRSTUVWXYZ',
  _lowers: 'abcdefghjkmnpqrstuvwxyz',
  _specs: '+!@#$%&*',
  get _characters() {
    return this._numbers + this._uppers + this._lowers + this._specs;
  },

  _getRandomByte: function () {
    // http://caniuse.com/#feat=getrandomvalues
    if (window.crypto && window.crypto.getRandomValues) {
      const result = new Uint8Array(1);
      window.crypto.getRandomValues(result);
      return result[0];
    } else if (window.msCrypto && window.msCrypto.getRandomValues) {
      const result = new Uint8Array(1);
      window.msCrypto.getRandomValues(result);
      return result[0];
    } else {
      return Math.floor(Math.random() * 256);
    }
  },

  _shuffle: (array: string[]) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  },

  generate: function () {
    const number = this._numbers[this._getRandomByte() % this._numbers.length];
    const lower = this._lowers[this._getRandomByte() % this._lowers.length];
    const upper = this._uppers[this._getRandomByte() % this._uppers.length];
    const spec = this._specs[this._getRandomByte() % this._specs.length];
    const array = [number, upper, spec, lower];
    for (let i = 0; i < 4; i++) {
      array.push(this._characters[this._getRandomByte() % this._characters.length]);
    }
    return this._shuffle(array).join('');
  },
};

export default Password;
